export default function baseEnv() {
  return {
    route: {
      baseRoute: '/',
    },
    managerPortalURL: 'https://portal-hml.aberto.com.br',
    managerApi: {
      baseURL: 'https://api-hml.aberto.com.br/onboarding/v1',
      endpoints: {
        address: {
          get: '/address/search/zip-code/:zipCode',
        },
        company: {
          verifyExists: '/company/:companyId/verify-exists',
          acceptanceTerm: '/company/acceptance-term',
          create: '/Company/create-onboarding',
        },
        category: {
          get: '/company-category/public/identification-info',
        },
        plan: {
          verifyExists: '/plan/:planId/verify-exists',
        },
      },
      reCaptchaSiteKey: '6LfMvOEaAAAAAEq97My_RS4KbC5OyPzmfdh4pIDL',
    },
  }
}
